<script>
export default {
  name: "CleanLayout",
};
</script>

<template>
  <router-view />
</template>
